var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 3.04572L35.7264 20.9583L35.9549 21.6156L36.6506 21.6298L55.6106 22.0162L40.4987 33.4731L39.9442 33.8935L40.1457 34.5596L45.6372 52.711L30.0712 41.8792L29.5 41.4817L28.9288 41.8792L13.3628 52.711L18.8543 34.5596L19.0558 33.8935L18.5013 33.4731L3.38943 22.0162L22.3494 21.6298L23.0451 21.6156L23.2736 20.9583L29.5 3.04572Z",
    fill: "#AA5FCC",
    stroke: "#9B45C1",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/starFill.27e1862e5154a54379cc116df5173db0.svg";
export { ForwardRef as ReactComponent };